// extracted by mini-css-extract-plugin
module.exports = {"tradeButtonSeparator":"TradeButton_tradeButtonSeparator___trf9","tradeButton":"TradeButton_tradeButton__hemDK","tradeButtonSimple":"TradeButton_tradeButtonSimple__3si7y"};